import { useForm, Controller } from "react-hook-form";
import { Button, Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/SaveRounded";
import ApiAuth from "../../../core/api/api.auth";

import SwalMessage from "../_Components/SwalMessage";

const ChangePassword = () => {
  const {
    handleSubmit: handleSubmit,
    control: control,
    formState: { errors: errors, isSubmitting },
  } = useForm({ defaultValues: { id: 0 } });

  const onSubmit = async (data) => {
    try {
      // data.phoneNumber = data.phoneNumber.replaceAll(" ", "");
      const response = await ApiAuth.changePassword(data);
      if (response.succeeded == true) {
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } else
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      // history.goBack();
    } catch (error) {
    }
  };

  return (
    <div className={`card card-custom`}>
      {/* Start Box Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">
            تغییر رمز عبور
          </span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm">
            جهت تغییر رمز عبور فرم زیر را تکمیل نمایید
          </span>
        </h3>
      </div>
      {/*Start body */}
      <div className="card-body pt-3 ">
        {/* Start Box Header */}
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="border-top pt-3">
            <Col lg="3" xs="12" sm="6">
              <Controller
                name="oldPassword"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="رمز عبور قدیم"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.oldPassword && (
                <small className="text-danger">
                  لطفا رمز عبور قدیم را وارد نمایید
                </small>
              )}
            </Col>
            <Col lg="3" xs="12" sm="6">
              <Controller
                name="password"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="رمز عبور جدید"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.password && (
                <small className="text-danger">
                  لطفا رمز عبور جدید را وارد نمایید
                </small>
              )}
            </Col>
            <Col lg="3" xs="12" sm="6">
              <Controller
                name="confirmPassword"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="تکرار رمز عبور جدید"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.confirmPassword && (
                <small className="text-danger">
                  لطفا تکرار رمز عبور جدید را وارد نمایید
                </small>
              )}
            </Col>
            <Col lg="3" xs="12" sm="6" className="mt-3 ">
              <Button
                variant="success w-100"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <Spinner animation="border" variant="warning" size="sm" />
                )}
                <SaveIcon /> ثبت
              </Button>
              <Link to="/forgotPassword" className="mt-5  d-block">
                <i
                  className="fa fa-key text-primary mr-1"
                  style={{ fontSize: "12px" }}
                ></i>
                در صـورت فـراموشی رمـز عبـور کلیـک نمـایـید
              </Link>
            </Col>
          </div>
        </form>
      </div>{" "}
    </div>
  );
};

export default ChangePassword;
